import { Injectable } from '@angular/core';
import { BehaviorSubject, forkJoin } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Notification } from '../models';
import { AlloxApiService } from './allox-api.service';

interface INotificationItem {
  icon: string | string[];
  message: string;
}

@Injectable({ providedIn: 'root' })
export class NotificationService {

  private path = '/notifications';

  private notificationItemSubject = new BehaviorSubject<INotificationItem[]>([]);

  public get notificationItems$() { return this.notificationItemSubject; }

  constructor(
    private http: AlloxApiService,
  ) { }

  public reload() {
    forkJoin([
      this.updateEmergencyPlatform().pipe(
        map(pfs => pfs.map(this.makeItemByEmergencyPlatform.bind(this)))
      )
    ]).pipe(
      map(results => results.reduce((prev, current) => prev.concat(current), [] as INotificationItem[])),
      tap((results: INotificationItem[]) => this.notificationItems$.next(results))
    ).subscribe();
  }

  private updateEmergencyPlatform() {
    return this.http.get<[]>(this.path).pipe(
      map(objs => objs.map(obj => new Notification(obj)))
    );
  }

  private makeItemByEmergencyPlatform(notification: Notification) {
    return {
      icon: 'exclamation-circle',
      message: `${notification.text}`
    } as INotificationItem;
  }
}
